if (!customElements.get('ey-home-menu')) {
  customElements.define('ey-home-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      this.grid = this.querySelector('[data-ey-menu-grid]');
      this.scroller = this.querySelector('.ey-home-menu__scroll');
      this.closeButton = this.querySelector('.ey-home-menu__close');
      if (!this.dialog || !this.grid || !this.closeButton) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      document.addEventListener('click', (event) => {
        const opener = event.target.closest?.('[data-ey-home-menu-open]');
        if (!opener || opener.getAttribute('aria-controls') !== this.dialog.id) return;
        event.preventDefault();
        this.open(opener);
      }, options);
      this.closeButton.addEventListener('click', () => this.close(), options);
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      }, options);
      this.dialog.addEventListener('close', () => this.restorePage(), options);
      this.dialog.addEventListener('click', (event) => {
        const trigger = event.target.closest?.('[data-ey-menu-panel-trigger]');
        if (trigger) this.showPanel(trigger);
        else if (event.target.closest?.('[data-ey-menu-back]')) this.showGrid();
        else if (event.target.closest?.('a[href]')) this.close();
      }, options);
    }

    open(opener) {
      if (this.dialog.open) return;
      this.opener = opener;
      this.showGrid(false);
      this.dialog.showModal();
      this.scrollStyles = [document.documentElement, document.body].map((element) => ({
        element, value: element.style.getPropertyValue('overflow'), priority: element.style.getPropertyPriority('overflow')
      }));
      document.dispatchEvent(new CustomEvent('evayong:navigation-opened'));
      this.scrollStyles.forEach(({ element }) => element.style.setProperty('overflow', 'hidden'));
      opener.setAttribute('aria-expanded', 'true');
      window.__evayongOrnaments?.refresh(this.dialog);
      this.closeButton.focus({ preventScroll: true });
    }

    close() {
      if (this.dialog.open) this.dialog.close();
      this.restorePage();
    }

    restorePage(restoreFocus = true) {
      if (!this.scrollStyles) return;
      this.scrollStyles.forEach(({ element, value, priority }) => {
        if (value) element.style.setProperty('overflow', value, priority);
        else element.style.removeProperty('overflow');
      });
      this.scrollStyles = null;
      this.opener?.setAttribute('aria-expanded', 'false');
      document.dispatchEvent(new CustomEvent('evayong:navigation-closed'));
      if (restoreFocus && this.opener?.isConnected) this.opener.focus({ preventScroll: true });
    }

    showPanel(trigger) {
      const key = trigger.dataset.eyMenuPanelTrigger;
      const panel = [...this.querySelectorAll('[data-ey-menu-panel]')].find((element) => element.dataset.eyMenuPanel === key);
      if (!panel) return;
      this.panelOpener = trigger;
      this.grid.hidden = true;
      this.querySelectorAll('[data-ey-menu-panel]').forEach((element) => { element.hidden = element !== panel; });
      trigger.setAttribute('aria-expanded', 'true');
      this.scroller.scrollTop = 0;
      panel.querySelector('[data-ey-menu-back]').focus({ preventScroll: true });
    }

    showGrid(restoreFocus = true) {
      this.querySelectorAll('[data-ey-menu-panel]').forEach((panel) => { panel.hidden = true; });
      this.querySelectorAll('[data-ey-menu-panel-trigger]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      this.grid.hidden = false;
      this.scroller.scrollTop = 0;
      if (restoreFocus) this.panelOpener?.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      if (this.dialog?.open) this.dialog.close();
      this.restorePage(false);
    }
  });
}
